
type StatusType =
    | 'present'
    | 'absent'
    | 'half-day'
    | 'late'
    | 'early'
    | 'holiday'
    | 'weekend'
    | 'leave';

interface Props {
    status: StatusType;
}

const statusStyles: Record<StatusType, string> = {
    present: 'bg-green-100 text-green-600',
    absent: 'bg-red-100 text-red-600',
    'half-day': 'bg-orange-100 text-orange-600',
    late: 'bg-yellow-100 text-yellow-600',
    early: 'bg-blue-100 text-blue-600',
    holiday: 'bg-amber-100 text-amber-600',
    weekend: 'bg-indigo-100 text-indigo-600',
    leave: 'bg-purple-100 text-purple-600',
};

const StatusBadge: React.FC<Props> = ({ status }) => {
    const baseClasses = 'text-sm font-regular px-3 py-1 rounded capitalize';
    const colorClasses = statusStyles[status];

    return <span className={`${baseClasses} ${colorClasses}`}>{status.replace('-', ' ')}</span>;
};

export default StatusBadge